<template>
	<div class="p4">
		<!-- Language selector -->
		<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
			<div class="pr2 xs-12 fs4 lh125 fw7 pb1">{{ $t("language") }}</div>
			<core-select-locale
				class="xs-12"
				size="xsmall"
				v-model="selectedLocale"
			/>
		</div>
		<div class="fw7 pb2">{{ $t("course_title") }}</div>
		<j-base-input-text
			name="name"
			v-model="createForm.name"
			v-validate="'required'"
			:status="errors && errors.first('name') ? 'error' : null"
		/>
		<!-- Error message -->
		<div
			class="xs-12 fs3 lh125 cError mt1"
			v-if="errors && errors.first('name')"
		>
			{{ errors ? errors.first("name") : null }}
		</div>
		<div class="pb2 mt4 fw7">{{ $t("description") }}</div>
		<j-base-input-long-text v-model="createForm.description" />
		<div class="fw7 pb2 mt4">{{ $t("version") }}</div>
		<j-base-input-text v-model="createForm.version" />
		<div class="fw7 pb2 mt4">{{ $t("categories") }}</div>
		<input-categories-list v-model="createForm.categories" />
		<j-button :isLoading="isLoading" class="mt8" @click="createCourse">{{
			$t("add")
		}}</j-button>
	</div>
</template>

<script>
import InputCategoriesList from "../components/InputCategoriesList"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseInputLongText from "@/components/JBaseInputLongText/"
import JButton from "@/components/JButton/"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"
import api from "@/api/gql.js"
import queries from "../utils/queries.js"
import { checkSuccess } from "../utils/helpers.js"
import { i18n } from "@/locales/setup.js"

export default {
	components: {
		InputCategoriesList,
		JBaseInputText,
		JBaseInputLongText,
		JButton,
		CoreSelectLocale
	},

	data() {
		return {
			isLoading: false,
			createForm: {
				name: null,
				description: null,
				version: null,
				categories: []
			},
			componentId: null,
			courseId: null,
			selectedLocale: i18n.locale
		}
	},

	methods: {
		async createCourse() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.isLoading = true

			/* 1th Step
			 * Create course in education module
			 */
			let variables = {
				input: {
					version: this.createForm?.version,
					categories: ["course"].concat(this.createForm?.categories)
				}
			}

			let res = await api({ query: queries.createCourse, variables })

			if (
				!checkSuccess(
					res,
					"createCourse",
					this.$t("errors.general"),
					this.$store
				)
			) {
				this.isLoading = false
				return
			} else {
				this.courseId = res?.data?.createCourse?.createdStatus?.id
			}

			/* 2th Step
			 * Upsert name in L10n table
			 */
			variables = {
				l10n: {
					key: `courses-${this.courseId}-name`,
					locale: this.selectedLocale,
					value: this.createForm?.name
				}
			}

			res = await api({ query: queries.upsertL10n, variables })

			if (
				!checkSuccess(res, "upsertL10n", this.$t("errors.general"), this.$store)
			) {
				this.isLoading = false
				return
			}

			/* 3th Step
			 * Upsert description in L10n table
			 */
			if (this.createForm?.description?.length) {
				variables = {
					l10n: {
						key: `courses-${this.courseId}-description`,
						locale: this.selectedLocale,
						value: this.createForm?.description
					}
				}

				res = await api({ query: queries.upsertL10n, variables })

				if (
					!checkSuccess(
						res,
						"upsertL10n",
						this.$t("errors.general"),
						this.$store
					)
				) {
					this.isLoading = false
					return
				}
			}
			this.isLoading = false
			this.$emit("course:created", this.courseId)
		}
	}
}
</script>
